import { Checkbox, DropdownItemNew } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC, useEffect, useRef } from 'react'

interface FilterItemProps {
    checked: boolean
    label: string
    onToggle: () => void
}

// Separate component for each filter item to properly use hooks
const FilterItem: FC<FilterItemProps> = ({ checked, label, onToggle }) => {
    const wrapperRef = useRef<HTMLDivElement>(null)

    // Use native event listener to capture click before React's synthetic event
    useEffect(() => {
        const wrapper = wrapperRef.current
        if (!wrapper) return

        const handleNativeClick = (e: Event) => {
            e.stopPropagation()
            e.preventDefault()
            onToggle()
        }

        // Use capture phase to intercept before React's handler
        wrapper.addEventListener('click', handleNativeClick, true)

        return () => {
            wrapper.removeEventListener('click', handleNativeClick, true)
        }
    }, [onToggle])

    return (
        <DropdownItemNew
            sx={{
                padding: 0,
                margin: 0,
            }}
        >
            <Box ref={wrapperRef}>
                <Checkbox
                    checked={checked}
                    onChange={() => {}}
                    label={label}
                    sx={{
                        width: '100%',
                        height: '48px',
                        padding: '0px 16px',
                        cursor: 'pointer',
                        '.MuiTypography-root': {
                            ml: 2,
                        },
                    }}
                />
            </Box>
        </DropdownItemNew>
    )
}

export default FilterItem
